/* eslint-disable react-hooks/exhaustive-deps */
import _ from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";

import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { Pagination } from "../../components/Pagination";
import Search from "../../components/Search";
import { TableConfig } from "../../config/Config";

import Loader from "../../components/Loader";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";

import { useTranslation } from "react-i18next";
import { PerPage } from "../../components/PerPage";
import styles from "./Teams.module.scss";

const tableHeader = [
  { name: "coach", label: "Coach", width: "15%" },
  { name: "id", label: "Employee Id", width: "5%" },
  { name: "department_name", label: "Department", width: "15%" },
  { name: "sub_functional_unit", label: "Sub Unit", width: "15%" },
  { name: "last_session", label: "Last Session", width: "15%" },
  { name: "upcoming_session", label: "Upcoming Session", width: "15%" },
  { name: "total_coachees", label: "Total coachees", width: "15%" },
];

const SupportAdminTable = ({ selectedCampaign, selectedCountry }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { addNotification } = useNotification();
  const [perPage, setPerPage] = useState(TableConfig.resultPerPage);
  const [searchKey, setSearchKey] = useState("");

  const [teamData, setTeamData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [offset, setOffset] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [columnName, setColumnName] = useState("coach");
  const [sortOrder, setSortOrder] = useState("asc");
  const [uid] = useState(getLocalValue("uid"));

  useEffect(() => {
    if (selectedCountry) {
      fetchData();
    }
  }, [
    offset,
    columnName,
    sortOrder,
    selectedCountry,
    selectedCampaign,
    searchKey,
    perPage,
  ]);

  // fetch from getSessionDetails api
  async function fetchData() {
    setIsLoading(true);
    let obj = {
      limit: perPage,
      page: offset,
      column_name: columnName,
      order: sortOrder,
      search: searchKey,
      country_id: selectedCountry,
      campaign_id: selectedCampaign,
    };
    try {
      const response = await apiRequest.get(`/api/supportAdminTeamSessions`, {
        params: obj,
      });

      if (response.status === 200) {
        const data = response.data;

        const teamsList = data.data;
        setTeamData(teamsList);
        setTotalData(data.totalData);
        setIsLoading(false);
      } else {
        addNotification(
          t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
          "error"
        );
        setIsLoading(false);
      }
    } catch (error) {
      addNotification("something went wrong, please try again", "error");
      setIsLoading(false);
    }
  }

  const handlePaginationChange = offset => {
    setOffset(offset.selected + 1);
  };

  const sortData = name => {
    setColumnName(name);
    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);
    return (
      <React.Fragment>
        <TableRow
          className={`${styles.tableRow} ${open ? styles.openRow : ""}`}
        >
          <TableCell
            className={`${open ? styles.openRow : ""}`}
            onClick={() => {
              history.push(`/teams/details/${row.uid}`);
            }}
          >
            {row.coach}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.id}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.department_name}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.sub_functional_unit}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.last_session}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {" "}
            {row.upcoming_session}{" "}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {" "}
            {row.total_coachees}{" "}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.coachees && row.coachees.length > 0 && (
              <IconButton
                aria-label="expand row"
                size="small"
                style={{ outline: "none" }}
                onClick={e => {
                  e.stopPropagation();
                  setOpen(!open);
                }}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            )}
          </TableCell>
        </TableRow>
        <TableRow className={styles.tableDetailsRow}>
          <TableCell
            style={{ padding: "0", borderBottomWidth: open ? "1px" : 0 }}
            colSpan={8}
          >
            <Collapse
              in={open}
              timeout="auto"
              style={{
                padding: "16px 30px",
                overflow: "hidden",
                marginTop: "-22px",
              }}
              unmountOnExit
            >
              <TableContainer component={Paper} elevation={0}>
                <Table aria-label="Team" className={styles.subTable}>
                  <TableHead className={styles.tableHead}>
                    <TableRow>
                      <TableCell>Coachees</TableCell>
                      <TableCell>Employee Id</TableCell>
                      <TableCell>Department</TableCell>
                      <TableCell>Sub Unit</TableCell>
                      <TableCell>Last Session</TableCell>
                      <TableCell>Upcoming Session</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.coachees &&
                      row.coachees.map((subRow, index) => (
                        <TableRow
                          onClick={() => {
                            history.push(`/teams/details/${subRow.coachee_id}`);
                          }}
                          key={index}
                        >
                          <TableCell className={styles.subTableRow}>
                            {subRow.coachee}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.employee_id}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.department}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.sub_functional_unit}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.last_session}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.upcoming_session}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Fragment>
      <Search
        handleSearch={val => {
          setSearchKey(val);
          setOffset(1);
        }}
      />
      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="Team" className={styles.table}>
          <TableHead className={styles.tableHead}>
            <TableRow>
              {tableHeader.map((tableHead, index) => (
                <TableCell
                  key={index}
                  style={{ width: tableHead.width, padding: "14px 10px" }}
                  className={styles.tableHeadCell}
                  onClick={() => {
                    sortData(tableHead.name);
                  }}
                >
                  {tableHead.label}

                  {columnName === tableHead.name && sortOrder === "asc" && (
                    <span>
                      <KeyboardArrowUpIcon fontSize="small" />
                    </span>
                  )}
                  {columnName === tableHead.name && sortOrder === "desc" && (
                    <span>
                      <KeyboardArrowDownIcon fontSize="small" />
                    </span>
                  )}
                </TableCell>
              ))}
              <TableCell style={{ width: "3%" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teamData &&
              teamData.map((row, index) => <Row key={index} row={row} />)}
            {_.isEmpty(teamData) && (
              <TableRow style={{ borderBottom: "1px solid #eeeeee" }}>
                <TableCell style={{ borderBottom: 0 }} colSpan={7}>
                  {t("common.noRecordFound")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalData > perPage && (
        <div className={styles.footer}>
          <PerPage limit={perPage} setLimit={setPerPage} />
          <Pagination
            totalData={totalData}
            limit={perPage}
            offset={offset}
            handlePageClick={offset => {
              handlePaginationChange(offset);
            }}
          />
        </div>
      )}
      {isLoading && (
        <Loader
          style={{
            position: "fixed",
            top: "0",
            bottom: "0",
            left: "200px",
            right: 0,
            margin: "auto",
            backgroundColor: "rgba(0,0,0,.1)",
          }}
        />
      )}
    </Fragment>
  );
};

export default SupportAdminTable;
